import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Illustration } from 'fpay-ui';
import { Grid } from '@material-ui/core';
import RefundCard from '@components/RefundCard';
import { useTranslation } from 'react-i18next';

const Document = styled.div`
  position: fixed;
  bottom: -200%;
`;
const Page = styled.div`
  width: 572px;
  height: 510px;
  float: left;
  padding: 0 32px 32px 32px;
  overflow: hidden;
  border: solid 1px #828aa2;
  background-color: #fff;
`;

const Title = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: 0.32px;
  text-align: right;
  color: #828aa2;
`;

const SubTitle = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: 0.32px;
  text-align: right;
  color: #828aa2;
`;

const PdfRefund = ({ idElement, refElement }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page id={idElement} ref={refElement}>
        <Grid container style={{ height: '100%' }}>
          <Grid item xs={12} container style={{ top: 0, marginBottom: '16px' }}>
            <Grid item xs={4}>
              <Illustration name="logo_fpay" width="76px" height="76px" />
            </Grid>

            <Grid item xs={8} align="left" style={{ alignSelf: 'center' }}>
              <Title>{t('transactions.refunds.title')}</Title>
              <SubTitle>{t('paymentsFoundsOut.success.noValid')}</SubTitle>
            </Grid>
          </Grid>
          <RefundCard marginTop="0px" detailAlwaysOpen />
        </Grid>
      </Page>
    </Document>
  );
};

PdfRefund.propsTypes = {
  idElement: PropTypes.string,
  refElement: PropTypes.object,
  currentTransaction: PropTypes.object.isRequired,
  currentRefund: PropTypes.object.isRequired,
};

PdfRefund.defaultProps = {
  idElement: undefined,
  refElement: undefined,
};

export default PdfRefund;
